import React from "react";
import Reveal from "../common/Reveal";
import certificateImage from "../../assets/images/US_CERTIFICATE.png";

const CertificateCta: React.FC = () => {
  return (
    <section
      id="certificate"
      className="bg-gradient-to-b from-primary/95 via-primary to-primary/95 py-20 sm:py-24"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-6 lg:flex-row lg:items-center lg:gap-16">
        <Reveal className="w-full space-y-6 text-center lg:w-1/2 lg:text-left">
          <p className="text-xs uppercase tracking-[0.35em] text-accentNavy/50">
            Earn your milestone
          </p>
          <h2 className="font-display text-3xl text-accentNavy sm:text-4xl lg:text-5xl">
            Earn a certificate that feels as good as your first song.
          </h2>
          <p className="text-base text-accentNavy/70 lg:text-lg">
            Complete a carefully guided path from first chords to full
            performance and receive a shareable, instructor-signed certificate.
            It is a gentle but clear milestone that shows you did the work,
            with recordings and feedback to back it up.
          </p>
          <p className="text-sm text-accentNavy/60 lg:text-base">
            Use it as a personal marker of progress, to stay accountable, or
            simply as a reminder that you finally gave your musical side the
            time and space it deserves.
          </p>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-3 lg:justify-start">
            <a
              href="#plan-tabs"
              className="inline-flex items-center justify-center rounded-full bg-accentNavy px-8 py-3 text-sm font-semibold uppercase tracking-wide text-primary shadow-brand transition-transform duration-200 hover:-translate-y-0.5 lg:px-9 lg:py-3.5 lg:text-base"
            >
              Reserve your spot
            </a>
          </div>
        </Reveal>

        <Reveal
          delay={160}
          className="w-full lg:w-1/2"
        >
          <div className="relative mx-auto max-w-md lg:max-w-xl overflow-hidden rounded-3xl border border-accentNavy/15 bg-gradient-to-br from-white to-slate-50/90 p-4 shadow-[0_20px_60px_-35px_rgba(9,32,63,0.8)]">
            <div className="pointer-events-none absolute -left-10 top-6 h-32 w-32 rounded-full bg-accentGold/10 blur-2xl" />
            <div className="pointer-events-none absolute -right-8 bottom-0 h-28 w-28 rounded-full bg-accentNavy/10 blur-2xl" />

            <div className="relative overflow-hidden rounded-2xl border border-accentNavy/10 bg-white/90">
              <img
                src={certificateImage}
                alt="Ukulele Seekho Course Certificate"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="relative mt-4 flex items-center justify-between gap-3 rounded-2xl border border-accentNavy/10 bg-white/90 px-4 py-3">
              <div className="space-y-0.5 text-left">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accentNavy/50">
                  Sample certificate
                </p>
                <p className="text-sm text-accentNavy/80">
                  Signed by instructors · Verifiable completion
                </p>
              </div>
              {/* <div className="flex items-center gap-1.5 rounded-full bg-accentNavy px-3 py-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-300" />
                <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-primary/90">
                  In session
                </span>
              </div> */}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CertificateCta;

